interface StepIndicatorProps {
  currentStep: number;
  steps: { label: string; description?: string }[];
}

function CheckIcon() {
  return (
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  );
}

export function StepIndicator({ currentStep, steps }: StepIndicatorProps) {
  return (
    <nav aria-label="Registration progress" className="mb-8">
      <ol className="flex items-center w-full">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;

          return (
            <li key={index} className="flex-1 flex flex-col items-center relative">
              {/* Connecting line between steps */}
              {index > 0 && (
                <div
                  className={`absolute top-4 -left-1/2 w-full h-0.5 ${
                    isCompleted ? 'bg-primary' : 'bg-slate-200'
                  }`}
                />
              )}
              {/* Step circle */}
              <div
                className={`relative z-10 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                  isCompleted
                    ? 'bg-primary text-white'
                    : isCurrent
                      ? 'bg-primary text-white ring-4 ring-primary/20'
                      : 'bg-slate-200 text-slate-500'
                }`}
              >
                {isCompleted ? <CheckIcon /> : index + 1}
              </div>
              {/* Step label */}
              <span
                className={`mt-2 text-xs font-medium text-center ${
                  isCurrent ? 'text-primary' : isCompleted ? 'text-primary-dark' : 'text-slate-500'
                }`}
              >
                {step.label}
              </span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
